import React from 'react'
import { Title } from '../Title'
import './Table.scss'

interface IProps<T> {
  columnNames: string[]
  rows: T[]
  description?: string
  title?: string
  gridTemplateColumns?: string
}

export function Table<T>({
  columnNames,
  description,
  rows,
  title,
  gridTemplateColumns = '1fr '.repeat(columnNames.length),
}: IProps<T>) {
  return (
    <div className="arc-table">
      <Title title={title} description={description} className="arc-table__title" />
      <table className="arc-table--table" style={{ gridTemplateColumns }}>
        <thead>
          <tr>
            {columnNames.map((name) => (
              <th key={name}>{name}</th>
            ))}
          </tr>
        </thead>
        <tbody>{rows}</tbody>
      </table>
    </div>
  )
}
